/**
 * @generated SignedSource<<5c9262b125e171a74bb6e4b82a7c6dc7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
export type shopCatalogueQuery$variables = {
  hubName: string;
};
export type shopCatalogueQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly lat: number;
        readonly lng: number;
        readonly name: string;
        readonly services: ReadonlyArray<HubService>;
      };
      readonly slug: string;
      readonly sncProducts: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly organization: {
            readonly id: string;
            readonly logo: {
              readonly id: string;
              readonly variant: string;
            } | null | undefined;
            readonly name: string;
            readonly publicShowcaseImageId: {
              readonly id: string;
              readonly variant: string;
            } | null | undefined;
          };
          readonly product: {
            readonly brand: {
              readonly id: string;
              readonly name: string;
              readonly organization: {
                readonly id: string;
                readonly name: string;
              };
            };
            readonly category: {
              readonly i18N: any;
              readonly id: string;
              readonly name: string;
            } | null | undefined;
            readonly id: string;
          };
          readonly stock: number;
          readonly " $fragmentSpreads": FragmentRefs<"SncProductCardFragment" | "SncProductDrawerFragment">;
        }>;
      };
    };
    readonly id: string;
    readonly name: string;
    readonly organization: {
      readonly id: string;
      readonly slug: string;
    };
    readonly street: string;
  };
};
export type shopCatalogueQuery = {
  response: shopCatalogueQuery$data;
  variables: shopCatalogueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "services",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stock",
  "storageKey": null
},
v10 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "variant",
        "value": "PUBLIC"
      }
    ],
    "kind": "ScalarField",
    "name": "variant",
    "storageKey": "variant(variant:\"PUBLIC\")"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CloudflareImage",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": (v10/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CloudflareImage",
      "kind": "LinkedField",
      "name": "publicShowcaseImageId",
      "plural": false,
      "selections": (v10/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "i18N",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "HubMeta"
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v15 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v16 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v17 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Organization"
},
v18 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "CloudflareImage"
},
v19 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v20 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shopCatalogueQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v6/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v7/*:: as any*/),
                    "action": "THROW"
                  },
                  {
                    "alias": null,
                    "args": (v8/*:: as any*/),
                    "concreteType": "SncProductPage",
                    "kind": "LinkedField",
                    "name": "sncProducts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SncProduct",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*:: as any*/),
                          (v9/*:: as any*/),
                          (v11/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Brand",
                                "kind": "LinkedField",
                                "name": "brand",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Organization",
                                    "kind": "LinkedField",
                                    "name": "organization",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      (v3/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v12/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SncProductCardFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SncProductDrawerFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "sncProducts(filter:{\"active\":true})"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "shopCatalogueQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "concreteType": "SncProductPage",
                "kind": "LinkedField",
                "name": "sncProducts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SncProduct",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v9/*:: as any*/),
                      (v11/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Brand",
                            "kind": "LinkedField",
                            "name": "brand",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imprint",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v12/*:: as any*/),
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": (v10/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sncProducts(filter:{\"active\":true})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7831661c40cdad642797c6f906035be",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": (v13/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v14/*:: as any*/),
        "hubMeta.hub.meta": (v13/*:: as any*/),
        "hubMeta.hub.meta.id": (v14/*:: as any*/),
        "hubMeta.hub.meta.lat": (v15/*:: as any*/),
        "hubMeta.hub.meta.lng": (v15/*:: as any*/),
        "hubMeta.hub.meta.name": (v16/*:: as any*/),
        "hubMeta.hub.meta.services": {
          "enumValues": [
            "INSTANT_BUY",
            "ONEDELIVERY",
            "CLICK_N_COLLECT",
            "RAFFLE",
            "LOCK_B2B",
            "LOCK_B2C",
            "SHOP_N_COLLECT"
          ],
          "nullable": false,
          "plural": true,
          "type": "HubService"
        },
        "hubMeta.hub.slug": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "SncProductPage"
        },
        "hubMeta.hub.sncProducts.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "SncProduct"
        },
        "hubMeta.hub.sncProducts.nodes.active": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Boolean"
        },
        "hubMeta.hub.sncProducts.nodes.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization": (v17/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.logo": (v18/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.logo.id": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.logo.variant": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.name": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.publicShowcaseImageId": (v18/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.publicShowcaseImageId.id": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.organization.publicShowcaseImageId.variant": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.priceAmount": (v19/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Product"
        },
        "hubMeta.hub.sncProducts.nodes.product.brand": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Brand"
        },
        "hubMeta.hub.sncProducts.nodes.product.brand.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.brand.name": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.brand.organization": (v17/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.brand.organization.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.brand.organization.imprint": (v20/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.brand.organization.name": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.category": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Category"
        },
        "hubMeta.hub.sncProducts.nodes.product.category.i18N": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "CategoryI18N"
        },
        "hubMeta.hub.sncProducts.nodes.product.category.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.category.name": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.description": (v20/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.id": (v14/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.name": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.photo": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "CloudflareImage"
        },
        "hubMeta.hub.sncProducts.nodes.product.photo.id": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.product.photo.variant": (v16/*:: as any*/),
        "hubMeta.hub.sncProducts.nodes.stock": (v19/*:: as any*/),
        "hubMeta.id": (v14/*:: as any*/),
        "hubMeta.name": (v16/*:: as any*/),
        "hubMeta.organization": (v17/*:: as any*/),
        "hubMeta.organization.id": (v14/*:: as any*/),
        "hubMeta.organization.slug": (v16/*:: as any*/),
        "hubMeta.street": (v16/*:: as any*/)
      }
    },
    "name": "shopCatalogueQuery",
    "operationKind": "query",
    "text": "query shopCatalogueQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    organization {\n      id\n      slug\n    }\n    hub {\n      id\n      slug\n      meta {\n        id\n        name\n        services\n        lat\n        lng\n      }\n      sncProducts(filter: {active: true}) {\n        nodes {\n          id\n          stock\n          organization {\n            id\n            name\n            logo {\n              id\n              variant(variant: PUBLIC)\n            }\n            publicShowcaseImageId {\n              id\n              variant(variant: PUBLIC)\n            }\n          }\n          product {\n            id\n            brand {\n              id\n              name\n              organization {\n                id\n                name\n              }\n            }\n            category {\n              id\n              name\n              i18N\n            }\n          }\n          ...SncProductCardFragment\n          ...SncProductDrawerFragment\n        }\n      }\n    }\n  }\n}\n\nfragment SncProductCardFragment on SncProduct {\n  id\n  priceAmount\n  stock\n  active\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n}\n\nfragment SncProductDrawerFragment on SncProduct {\n  id\n  priceAmount\n  stock\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n      organization {\n        id\n        name\n        imprint\n      }\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f3b22876052b4c2d5e1d79ff4c3dd62";

export default node;
